import DealScore from './deal-score';
export default DealScore;